

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface AdmissionTypeParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface AdmissionType {
    id?: number;
    code:string;
    name: string;
    isActive: string;
    isDefault: string;
    tenantId: any;
    branchId: any;
    category?:number;
    categoryName?:string;
    
  parameters?: AdmissionTypeParameter[];
  links?: any;
}

export abstract class AdmissionTypeData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(url: string): Observable<AdmissionType[]>;
  abstract create(url: string,data: AdmissionType): Observable<any>;
  abstract update(url: string,data: AdmissionType): Observable<any>;
  abstract delete(url: string): Observable<any>;
}